import { render, staticRenderFns } from "./Cup.vue?vue&type=template&id=187de10b"
import script from "./Cup.vue?vue&type=script&lang=js"
export * from "./Cup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports